import { ErrorHandler, Injectable } from '@angular/core';
import { Router, NavigationError } from '@angular/router';

@Injectable()
export class LazyLoadErrorHandler implements ErrorHandler {
  constructor(private router: Router) {
    // Captura falhas de navegação por módulos quebrados
    this.router.events.subscribe(event => {
      if (event instanceof NavigationError) {
        const isChunkLoadError =
          event.error?.message?.includes('Loading chunk') ||
          event.error?.message?.includes('dynamically imported') ||
          event.error?.message?.includes('failed') ||
          event.error?.message?.includes('Failed') ||
          event.error?.message?.includes('dynamic import');

        if (isChunkLoadError) {
          const failedUrl = event.url;
          window.location.href = failedUrl; // Recarrega a rota que falhou
        }
      }
    });
  }

  handleError(error: any): void {
    // Pode logar aqui outros erros, se quiser
    throw error;
  }
}
